import { IconButton } from '@mui/material';
import { IMediaFile, PostType } from 'interfaces/Backstage.interface';
import React, { FC, Fragment } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import {
  BodyFiveChilds,
  BodyFourChilds,
  BodyMoreChilds,
  BodyThreeChilds,
  BodyTwoChilds,
  Image,
  ImageNumberDisplay,
  MainBody,
  VideoCont,
} from './MultiMediaDisplayPreview.styles';
import { buttonStyles, editStyles } from './styled';

interface IMultiMediaDisplayPreview {
  mediaFiles: IMediaFile[] | [];
  handleClearMedia: () => void;
  handleEditMode: () => void;
  editingMode: boolean;
}
const MultiMediaDisplayPreview: FC<IMultiMediaDisplayPreview> = ({
  mediaFiles,
  handleClearMedia,
  handleEditMode,
  editingMode,
}) => {
  const getChildren = () => {
    return (
      <>
        {mediaFiles.map((media, index) => (
          <Fragment key={index}>
            {media.type === PostType.IMAGE ? (
              <Image key={media.url} src={media.url} loading="lazy" />
            ) : media.type === PostType.VIDEO ? (
              <VideoCont>
                <video
                  key={media.url}
                  src={media.url}
                  controls
                  style={{ width: '100%', height: '100%' }}
                />
              </VideoCont>
            ) : (
              <></>
            )}
          </Fragment>
        ))}
      </>
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      {mediaFiles.length > 0 && (
        <>
          <IconButton onClick={handleClearMedia} style={buttonStyles}>
            <ClearIcon />
          </IconButton>

          <IconButton onClick={handleEditMode} style={editStyles}>
            {editingMode ? 'Go Back' : 'Edit All'}
          </IconButton>
        </>
      )}

      {mediaFiles.length === 1 ? (
        <MainBody>{getChildren()}</MainBody>
      ) : mediaFiles.length === 2 ? (
        <BodyTwoChilds>{getChildren()}</BodyTwoChilds>
      ) : mediaFiles.length === 3 ? (
        <BodyThreeChilds>{getChildren()}</BodyThreeChilds>
      ) : mediaFiles.length === 4 ? (
        <BodyFourChilds>{getChildren()}</BodyFourChilds>
      ) : mediaFiles.length === 5 ? (
        <BodyFiveChilds>{getChildren()}</BodyFiveChilds>
      ) : mediaFiles.length > 5 ? (
        <>
          <BodyMoreChilds>
            {getChildren()}
            <ImageNumberDisplay className="show">
              <p>{mediaFiles.length - 4}+</p>
            </ImageNumberDisplay>
          </BodyMoreChilds>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default MultiMediaDisplayPreview;
